import { Api, Auth } from '~/services'
import { fetchArticle as _fetchArticle } from '../api/article';
import { fetchRecommendedArticles as _fetchRecommendedArticles } from '../api/article';

export const fetchArticle = ( slug ) => {
	return ( dispatch, getStore ) => {

		const params = Auth.getToken() ? {secure_token: Auth.getToken()} : {};
		
		return dispatch(
			async dispatch => {

				dispatch({
					type: 'REQUEST_ARTICLE'
				})

                const data = await _fetchArticle(params, slug);

				dispatch({
					type: 'RECEIVE_ARTICLE',
					article: data
				})

			}
		)
	}
}


export function removeArticle() {
	return ( dispatch, getStore ) => {
		dispatch({
			type: 'REMOVE_ARTICLE'
		})
	}
}


export function fetchComments( article_id ) {
	return ( dispatch, getStore ) => {

		var data = Auth.getToken() ? {secure_token: Auth.getToken()} : {};

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_COMMENTS'
				})

				Api.get( '/wp/article/' + article_id + '/comments', data, ( data, error ) => {
					dispatch({
						type: 'RECEIVE_COMMENTS',
                        comments: error ? [] : data
					})
				})

			}
		)
	}
}


export function sendComment( article_id, comment, comment_parent ) {
	return ( dispatch, getStore ) => {

		if( !comment || !Auth.getToken() ) return;

		var data = {
			comment: comment,
			secure_token: Auth.getToken()
		};
		if( comment_parent > 0 ) data.parent = comment_parent

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_COMMENTS'
				})

				Api.post( '/wp/article/' + article_id + '/comment', data, ( data, error ) => {
					if ( ! data.length || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_NEW_COMMENT',
						comments: data
					})
				})

			}
		)

	}
}


export function toggleArticleBookmark( id ) {

	return ( dispatch, getStore ) => {

		if( !Auth.loggedIn() || !id ) return;

		Api.post( '/wp/article/' + id + '/bookmark', {
			secure_token: Auth.getToken()
		}, ( data, error ) => {
			if ( error ) return;
			dispatch({
				type: 'RECEIVE_USER_BOOKMARKS',
				bookmarks: data.bookmarks
			})
			dispatch({
				type: 'RECEIVE_UPDATED_ARTICLE',
				article: data.article
			})
		})
	}
	
}


export function toggleArticleFlare( id ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		Api.post( '/wp/article/' + id + '/flare', {
			secure_token: Auth.getToken()
		}, ( data, error ) => {
			if ( ! data || error ) {
				return;
			}
			dispatch({
				type: 'RECEIVE_UPDATED_ARTICLE',
				article: data
			})
		})
	}
	
}


export function flareComment( id ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		Api.post( '/wp/comment/' + id + '/flare', {
			secure_token: Auth.getToken()
		}, ( data, error ) => {
			if ( ! data || error ) {
				return;
			}
			dispatch({
				type: 'RECEIVE_UPDATED_COMMENT',
				comment: data
			})
		})
	}
	
}


export function fetchRecommendedArticles( slug ) {
	return ( dispatch, getStore ) => {
		
		return dispatch(
			async dispatch => {

				dispatch({
					type: 'REQUEST_RECOMMENDED_ARTICLES'
				})

                const data = await _fetchRecommendedArticles({}, slug);

                dispatch({
                    type: 'RECEIVE_RECOMMENDED_ARTICLES',
                    articles: data
                });

			}
		)
	}
}


export function shareArticleToCamp( articleID, campID, statement ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !articleID || !campID ) return;
		
		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_SHARE_ARTICLE'
				})

				Api.post( '/wp/camp/' + campID + '/article/' + articleID + '/share', {
					secure_token: Auth.getToken(),
					statement: statement
				}, ( data, error ) => {
					if ( !data || error ) return;
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data
					})
				})

			}
		)
	}
}




// WEBPACK FOOTER //
// ./src/js/actions/article.js